import { cva } from "cva";
import { twMerge } from "tailwind-merge";

const STYLES_BY_INDEX = {
  FIRST_SUB_BADGE: "rounded-r-none",
  MIDDLE_SUB_BADGE: "rounded-none",
  LAST_SUB_BADGE: "rounded-l-none",
};

const styles = cva(
  [
    "inline-flex items-center rounded-xl px-3 text-[10px] font-bold text-[#1E212A]",
  ],
  {
    variants: {
      color: {
        green: ["bg-[#96D9C9]"],
        yellow: ["bg-[#FED430]"],
        "light-pink": ["bg-light-pink"],
      },
    },
    defaultVariants: {
      color: "green",
    },
  }
);

const Badge = ({ color, className, children, index = 0, numSubBadges = 1 }) => {
  const getSubBadgeStyle = (index, numSubBadges) => {
    if (numSubBadges <= 1) return "";
    if (index === 0) return STYLES_BY_INDEX.FIRST_SUB_BADGE;
    if (index === numSubBadges - 1) return STYLES_BY_INDEX.LAST_SUB_BADGE;
    return STYLES_BY_INDEX.MIDDLE_SUB_BADGE;
  };
  const subBadgeStyle = getSubBadgeStyle(index, numSubBadges);
  return (
    <span className={twMerge(styles({ color, className }), subBadgeStyle)}>
      {children}
    </span>
  );
};

export default Badge;
